import { Checkbox, Col, Empty, Form, Row, Spin, Switch, Table, type FormInstance } from "antd";
import React, { useEffect, useState } from "react";
import Text from "../../../components/Text/Text";
import color from "../../../resource/color";
import Button from "../../../components/Button/Button";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import Input from "../../../components/Input/Input";
import image from "../../../resource/image";
import Select from "../../../components/Select/Select";
import { icon } from "../../../resource";
import { handleNumberOnlyCopyPaste } from "../../../utility/validator";
import TableContainer from "../../../components/Table/TableContainer";
import { dealerTypeName } from "../../../definitions/campaign";
import {
  checkDupPDQuotaDetail,
  checkDupProductQuota,
  checkProductShop,
} from "../../../datasource/ProductQuotaDatasource";
import _ from "lodash";
import dayjs from "dayjs";
import { ModalSelectStore } from "../QuotaComponents/ModalSelectStore";
import { FlexCol, FlexRow } from "../../../components/Container/Container";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import { SettingConditionQuotaEachShop } from "../QuotaComponentsDup/ModalSettingQuotaCondition";
import InstuctionQuotaConditions from "../QuotaComponentsDup/InstructionQuotaConditionDup";
import ModalCheckProductDup from "../QuotaComponentsDup/ModalCheckProductDup";
import ModalCheckQuotaDup from "../QuotaComponentsDup/ModalCheckQuotaDup";
import StatusBadge from "../../../components/Badge/StatusBadge";
import { STATUS_WORD, STATUS_WORD_COLOR } from "../../../definitions/QuotaType";

const StepThreeDup = ({
  form1,
  form2,
  shopGroupData,
  isDetail,
  isEditing,
  zoneList,
  errorMessage,
  setErrorMessage,
  loadingStep,
  setLoadingStep,
}: {
  form1: FormInstance;
  form2: FormInstance;
  shopGroupData?: any;
  isDetail?: boolean;
  isEditing?: boolean;
  zoneList: any[];
  errorMessage?: { success: boolean; step: number; message: string } | null;
  setErrorMessage?: any;
  loadingStep?: boolean;
  setLoadingStep?: any;
}) => {
  const userCompany = JSON.parse(localStorage.getItem("company")!);
  const dataForm1 = form1.getFieldsValue(true);
  const dataForm2 = form2.getFieldsValue(true);
  const [modalSelectStore, setModalSelectStore] = useState(false);
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const [modalSettingCondition, setModalSettingCondition] = useState(false);
  const [modalIntructCondition, setModalIntructCondition] = useState(false);
  const [modalDupProducts, setModalDupProducts] = useState<{
    open: boolean;
    products: any[];
    cusName: string;
  }>({
    open: false,
    products: [],
    cusName: "",
  });
  const [modalDupQuota, setModalDupQuota] = useState<{
    open: boolean;
    quotas: any[];
    cusName: string;
  }>({
    open: false,
    quotas: [],
    cusName: "",
  });
  const _watchForm2 = Form.useWatch("stores", form2);
  const [dataShopSearch, setDataShopSearch] = useState([]);
  const [searchShopName, setSearchShopName] = useState("");
  const [searchShopZone, setSearchShopZone] = useState("");
  const [searchShopGroup, setSearchShopGroup] = useState("");
  const [loading, setLoading] = useState(false);

  const startDate = `${dayjs(dataForm1?.startDate).format("YYYY-MM-DD")} ${dayjs(dataForm1?.startTime).format("HH:mm")}`;
  const endDate = `${dayjs(dataForm1?.endDate).format("YYYY-MM-DD")} ${dayjs(dataForm1?.endTime).format("HH:mm")}`;

  const mapValueStoreList = async () => {
    const product = dataForm2;
    const paramCheckProductQuota: any[] = [];
    product?.stores?.map((p: any) => {
      product?.products?.forEach((prod: any) => {
        paramCheckProductQuota.push({
          customerCompanyId: Number(p.customerCompanyId),
          productId: Number(prod.productId),
        });
      });
    });

    const resCheckProQT = await checkDupProductQuota({
      productShop: paramCheckProductQuota,
      quotaId: isEditing || isDetail ? dataForm1?.quotaId : undefined,
      startDate,
      endDate,
    });

    const paramCheckProductShop: any = product?.products?.map((p) => {
      return {
        productId: Number(p.productId),
        customerCompanyId: product?.stores?.map((s) => Number(s.customerCompanyId)),
      };
    });
    const shopResult: any = await checkProductShop({
      productQuota: paramCheckProductShop,
    });

    const filteredAvilability = shopResult?.filter((product) =>
      dataForm2.products?.some((pid) => `${pid.productId}` === `${product.productId}`),
    );
    const mapStoreError = product?.stores?.map((item: any, index) => {
      const listCanNotOrder: any[] = [];
      const listCanNotProductQuota: any[] = [];
      if (userCompany.companyType === "Fertilizer") {
        filteredAvilability?.forEach((product) => {
          const canOrder = product?.shopQuota?.some(
            (shop) =>
              `${item.customerCompanyId}` === `${shop.customerCompanyId}` &&
              shop.productShopId !== null &&
              shop.productShopId !== undefined,
          );

          if (!canOrder) {
            listCanNotOrder.push(
              dataForm2.products?.find((p) => `${p.productId}` === `${product.productId}`),
            );
          }
        });
      }

      const proQuota = _.groupBy(
        resCheckProQT?.filter((p) => `${p.customerCompanyId}` === `${item.customerCompanyId}`),
        "customerCompanyId",
      )[`${item.customerCompanyId}`];

      if (proQuota?.length > 0) {
        proQuota?.map((pq) => {
          const find = `${item.customerCompanyId}` === `${pq.customerCompanyId}`;
          if (find) {
            listCanNotProductQuota.push(
              dataForm2.products?.find((p) => `${p.productId}` === `${pq.productId}`),
            );
          }
        });
      }
      if (dataForm1.limitOrderPerDayType === "allShop") {
        form2.setFieldValue(`orderPerDay-${item.customerCompanyId}`, dataForm1.countOrder);
      }

      return {
        ...item,
        isCanNotOrderProductList: userCompany.companyType === "Chemical" ? [] : listCanNotOrder,
        isCanNotProductQuotaList: listCanNotProductQuota,
        isCanNotCreate:
          listCanNotOrder.length === dataForm2.products?.length ||
          listCanNotProductQuota.length === dataForm2.products?.length
            ? true
            : false,
      };
    });
    form2.setFieldValue("stores", mapStoreError);
  };

  useEffect(() => {
    if (form2.getFieldValue("stores")?.length > 0) {
      mapValueStoreList();
    }
    setTimeout(() => {
      setLoadingStep(false);
    }, 500);
  }, [form1, form2, _watchForm2]);

  useEffect(() => {
    searchShop();
    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, [searchShopName, searchShopZone, searchShopGroup, _watchForm2]);

  const searchShop = () => {
    const dataSearch = (form2.getFieldValue("stores") || [])?.filter((s: any) => {
      const searchZone =
        !searchShopZone || searchShopZone === "ALL" || s.zone?.includes(searchShopZone);
      const searchKeyword =
        !searchShopName ||
        s.customerName?.includes(searchShopName) ||
        s.customerNo?.includes(searchShopName.toUpperCase());
      const searchGroup =
        !searchShopGroup ||
        searchShopGroup === "ALL" ||
        (s.customerGroupName || s.customerGroup) === searchShopGroup;
      return searchZone && searchKeyword && searchGroup;
    });
    setDataShopSearch(dataSearch);
  };
  const deleteShop = () => {
    setLoadingStep(true);
    const setDeleteShop = (form2.getFieldValue("stores") || [])?.filter((s: any) => s.isChecked);
    form2.setFieldValue("deleteShopsInGroup", [
      ...(form2.getFieldValue("deleteShopsInGroup") || []),
      ...setDeleteShop,
    ]);

    const storeListChecked =
      (form2.getFieldValue("stores") || [])?.filter((s: any) => !s.isChecked) || [];
    form2.setFieldValue("stores", storeListChecked);

    const _resetShop = setDeleteShop?.map((item: any) => {
      form2.setFieldValue(`quotaReceive-${item?.customerCompanyId}`, undefined);
      form2.setFieldValue(`orderPerDay-${item?.customerCompanyId}`, undefined);
    });

    setTimeout(() => {
      setLoadingStep(false);
    }, 500);
  };

  const columns = [
    {
      title: (
        <>
          {dataForm2.stores?.length > 0 && (
            <Checkbox
              checked={dataShopSearch?.every((s: any) => s.isChecked)}
              onClick={(e: any) => {
                const isChecked = e.target.checked;
                const storeList = form2.getFieldValue("stores") || [];
                const mapChecked = storeList.map((item: any) => {
                  const addData = {
                    quotaReceive: null,
                    quotaUsed: 0,
                    orderPerDay: null,
                    shopTotalQuotaId: isEditing ? item.shopTotalQuotaId : null,
                    isDuplicate: [],
                    nonProductShop: [],
                    quotaId: isEditing ? item.quotaId : null,
                    isActiveStatus: true,
                    productQuotaGroupId: isEditing ? item.productQuotaGroupId : null,
                  };
                  if (
                    (searchShopZone ? item.zone === searchShopZone : true) &&
                    (searchShopName
                      ? item.customerName.includes(searchShopName) ||
                        item.customerNo.includes(searchShopName.toUpperCase())
                      : true) &&
                    (searchShopGroup ? item.customerGroupName === searchShopGroup : true)
                  ) {
                    return {
                      ...item,
                      ...addData,
                      isChecked: isChecked,
                    };
                  }
                  return {
                    ...item,
                    ...addData,
                  };
                });
                form2.setFieldValue("stores", mapChecked);
              }}
            />
          )}
        </>
      ),
      width: 20,
      dataIndex: "customerNo",
      key: "customerNo",
      hidden: isDetail,
      render: (value: any, row: any, i: number) => {
        return {
          children: (
            <>
              <Checkbox
                checked={row.isChecked}
                onClick={(e: any) => {
                  const isChecked = e.target.checked;
                  form2.setFieldValue(["stores", i, "isChecked"], isChecked);
                }}
              />
            </>
          ),
        };
      },
    },
    {
      title: "รหัสร้านค้า",
      dataIndex: "customerNo",
      key: "customerNo",
      width: 130,
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{value}</Text>,
        };
      },
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Text>{value}</Text>
              <br />
              {row?.isCanNotOrderProductList?.length > 0 &&
                row?.isCanNotOrderProductList?.length < dataForm2?.products?.length && (
                  <>
                    <Text fontFamily='Sarabun' fontSize={14} color='warning'>
                      ร้านนี้ไม่มีสินค้าบางรายการจำหน่าย{" "}
                      <strong>{`${row?.isCanNotOrderProductList?.length} รายการ -`}</strong>{" "}
                      <u
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModalDupProducts({
                            open: true,
                            products: row?.isCanNotOrderProductList || [],
                            cusName: row.customerName,
                          });
                        }}
                      >
                        ดูเพิ่มเติม
                      </u>
                    </Text>
                    <br />
                  </>
                )}
              {row?.isCanNotOrderProductList?.length === dataForm2?.products?.length && (
                <>
                  <Text fontFamily='Sarabun' fontSize={14} color='error'>
                    ร้านนี้ไม่มีสินค้าโควตาทั้งหมดจำหน่าย{" "}
                    <strong>(รายการจะถูกลบออกเมื่อบันทึก)</strong>
                  </Text>
                  <br />
                </>
              )}
              {row?.isCanNotProductQuotaList?.length > 0 &&
                row?.isCanNotProductQuotaList?.length < dataForm2?.products?.length && (
                  <>
                    <Text fontFamily='Sarabun' level={6} color='warning'>
                      ร้านนี้มีสินค้า{" "}
                      <strong>{`${row?.isCanNotProductQuotaList?.length} รายการ `}</strong>
                      เข้าร่วมกับโควตาอื่น -{" "}
                      <u
                        style={{ cursor: "pointer" }}
                        onClick={async () => {
                          const mapParam = row.isCanNotProductQuotaList?.map((p: any) => {
                            return {
                              productId: p.productId,
                              customerCompanyId: row.customerCompanyId,
                            };
                          });
                          const getDetail = await checkDupPDQuotaDetail({
                            productShop: mapParam,
                            quotaId: isEditing || isDetail ? dataForm1?.quotaId : undefined,
                            startDate,
                            endDate,
                          });
                          setModalDupQuota({
                            open: true,
                            quotas: getDetail || [],
                            cusName: row.customerName,
                          });
                        }}
                      >
                        ดูเพิ่มเติม
                      </u>
                    </Text>
                    <br />
                  </>
                )}
              {row?.isCanNotProductQuotaList?.length === dataForm2?.products?.length && (
                <>
                  <Text fontFamily='Sarabun' fontSize={14} color='error'>
                    ร้านนี้มีสินค้าทั้งหมดเข้าร่วมกับโควตาอื่น{" "}
                    <strong>(รายการจะถูกลบออกเมื่อบันทึก)</strong>
                  </Text>
                  <br />
                </>
              )}
            </>
          ),
        };
      },
    },
    {
      title: "ประเภทคู่ค้า",
      dataIndex: "dealerType",
      key: "dealerType",
      width: 110,
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text level={6}>{dealerTypeName["DEALER"]}</Text>,
        };
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      width: 90,
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{value}</Text>,
        };
      },
    },
    {
      title: "กลุ่มลูกค้า",
      dataIndex: ["customerGroupName", "customerGroup"],
      key: "customerGroupName_customerGroup",
      width: 200,
      render: (_: any, row: any, index: number) => {
        const value = row.customerGroupName || row.customerGroup || "-";
        return {
          children: <Text>{value}</Text>,
        };
      },
    },
    {
      title: (
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Text
              color='white'
              fontSize={13}
              fontWeight={600}
              lineHeight={20}
              style={{ display: "block", marginBottom: 4 }}
            >
              จำกัดคำสั่งซื้อ / วัน
              <span style={{ color: color.error }}>*</span>
            </Text>
            <Text
              style={{ display: "block" }}
              color='warning'
              fontSize={12}
              fontWeight={600}
              lineHeight={2}
            >
              แบบนับรวมทุกสินค้า
            </Text>
          </div>
        </>
      ),
      dataIndex: "orderPerDay",
      key: "orderPerDay",
      width: 200,
      hidden: !dataForm1.limitOrderDay,
      render: (_: any, row: any, index: number) => {
        const keyName = `orderPerDay-${row.customerCompanyId}`;
        return (
          <Form.Item
            name={keyName}
            rules={[{ required: true, message: "โปรดระบุจำนวนคำสั่งซื้อ" }]}
          >
            <Input
              style={{ color: color.BK }}
              disabled={dataForm1.limitOrderPerDayType === "allShop" || isDetail}
              placeholder='ระบุจำนวน'
              suffix={
                <Text fontFamily='Sarabun' fontSize={14}>
                  ครั้ง / วัน
                </Text>
              }
              onKeyDown={handleNumberOnlyCopyPaste}
            />
          </Form.Item>
        );
      },
    },
    {
      title: "สถานะใช้งาน",
      dataIndex: "isActive",
      key: "isActive",
      width: 130,
      hidden: isEditing && !isDetail,
      render: (value: any, row: any, index: number) => {
        return (
          <StatusBadge
            key={index}
            label={STATUS_WORD[value]}
            bgColor={STATUS_WORD_COLOR[value]}
            borderRadius='20px'
          />
        );
      },
    },
    {
      title: "เปิด/ปิดรายร้าน",
      dataIndex: "oldIsActive",
      key: "oldIsActive",
      width: 150,
      hidden: !isEditing,
      render: (value: any, row: any, index: number) => {
        return (
          <Switch
            defaultChecked={!!value}
            onChange={(checked) => form2.setFieldValue(["stores", index, "isActive"], checked)}
            checkedChildren='เปิดใช้งาน'
            unCheckedChildren='ปิดใช้งาน'
          />
        );
      },
    },
  ].filter((col) => !col.hidden);

  return (
    <>
      {!isDetail && (
        <>
          <Row align='top'>
            <Col span={18} style={{ marginBottom: 10 }}>
              <Text level={5} fontWeight={700}>
                ร้านค้าที่เข้าร่วมโควตา <span style={{ color: color.error }}>*</span>
              </Text>
            </Col>
          </Row>
          {errorMessage?.success && errorMessage.step === 2 && (
            <Text level={5} color='error'>
              {errorMessage?.message}
            </Text>
          )}
        </>
      )}
      <Row gutter={[10, 10]} style={{ marginBottom: 12 }}>
        {dataForm2?.stores?.length > 0 && (
          <>
            <Col span={5}>
              <Input
                placeholder='ค้นหารหัส / ชื่อร้าน'
                suffix={<SearchOutlined />}
                onPressEnter={(e: any) => {
                  setLoading(true);
                  setSearchShopName(e.target.value);
                }}
                style={{ width: "100%" }}
              />
            </Col>
            <Col span={4}>
              <Select
                placeholder='เขตทั้งหมด'
                fontWeight={400}
                data={zoneList || []}
                value={searchShopZone || "ALL"}
                style={{ width: "100%" }}
                onChange={(e) => {
                  if (e) {
                    setSearchShopZone(e);
                  } else {
                    setSearchShopZone("ALL");
                  }
                }}
              />
            </Col>
            <Col span={4}>
              <Select
                fontWeight={400}
                placeholder='กลุ่มลูกค้าทั้งหมด'
                data={shopGroupData}
                defaultValue='ALL'
                onChange={(e) => setSearchShopGroup(e)}
                style={{ width: "100%" }}
              />
            </Col>
          </>
        )}
        {!isDetail && (
          <Col span={10} style={{ marginLeft: "auto" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
              }}
            >
              <Button
                title='ลบร้านค้า'
                icon={
                  <img
                    src={
                      dataForm2?.stores?.filter((s) => s.isChecked)?.length
                        ? icon.deleteWhite
                        : icon.deleteGray
                    }
                    style={{ width: 16, height: 16 }}
                  />
                }
                typeButton={
                  dataForm2?.stores?.filter((s) => s.isChecked)?.length
                    ? "danger"
                    : "light-disabled"
                }
                disabled={dataForm2?.stores?.filter((s) => s.isChecked)?.length === 0}
                onClick={() => {
                  setModalConfirmDelete(true);
                }}
                style={{ width: "max-content" }}
              />
              <Button
                title='เพิ่มร้านค้า'
                icon={<PlusOutlined />}
                onClick={() => setModalSelectStore(true)}
                style={{ width: "max-content" }}
              />
            </div>
          </Col>
        )}
      </Row>
      <Row justify={"end"} gutter={8} style={{ paddingBottom: "10px" }}>
        {loadingStep ? (
          <Col>
            <Spin size='small' />
          </Col>
        ) : (
          <Col style={{ paddingTop: "10px" }}>
            <Text>จำนวน {dataShopSearch?.length || 0} ร้านค้า</Text>
          </Col>
        )}

        {!isDetail && dataForm2?.stores?.length > 0 && dataForm1.limitOrderDay && (
          <Col>
            <Button
              onClick={() =>
                dataForm2?.stores?.filter((s) => s.isChecked).length > 0
                  ? setModalSettingCondition(true)
                  : setModalIntructCondition(true)
              }
              style={{ width: "max-content" }}
              icon={<img src={icon.scan} style={{ width: 18 }} />}
              title='เพิ่มเงื่อนไขเดียวกัน'
              typeButton='border-primary'
            />
          </Col>
        )}
      </Row>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40vh",
          }}
        >
          <Spin size='large' />
        </div>
      ) : (
        <Form form={form2}>
          <>
            {loadingStep ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40vh",
                }}
              >
                <Spin size='large' />
              </div>
            ) : (
              <TableContainer>
                <div style={{ overflowX: "auto" }}>
                  <Form.Item name='stores' noStyle>
                    <Table
                      columns={columns}
                      dataSource={dataShopSearch || []}
                      pagination={false}
                      scroll={{ x: "max-content", y: 520 }}
                      locale={{
                        emptyText: (
                          <div style={{ padding: "62px 0px" }}>
                            <Empty image={image.emptyShopTable} description={null} />
                            <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                              กรุณาเพิ่มร้านค้า
                            </Text>
                          </div>
                        ),
                      }}
                    />
                  </Form.Item>
                </div>
              </TableContainer>
            )}
          </>
        </Form>
      )}
      {modalSelectStore && (
        <ModalSelectStore
          showModalShop
          excludeCusCompanyId={dataForm2?.stores?.map((s) => s.customerCompanyId) || []}
          callBackShop={(stores) => {
            setLoadingStep(true);
            const storeSelected = dataForm2?.stores || [];
            form2.setFieldValue(
              "stores",
              storeSelected
                ? [
                    ...storeSelected,
                    ...stores.map((s) => ({
                      ...s,
                      oldIsActive: true,
                      isChecked: false,
                    })),
                  ]
                : stores.map((s) => ({
                    ...s,
                    oldIsActive: true,
                    isChecked: false,
                  })),
            );
            setErrorMessage(null);
            setModalSelectStore(false);
            setTimeout(() => {
              setLoadingStep(false);
            }, 500);
          }}
          currentSelectShop={dataForm2?.stores || []}
          company={userCompany.companyCode}
          onClose={() => {
            setModalSelectStore(false);
          }}
          customerType='DL'
          replaceSaveButtonTitle='บันทึก'
          replaceTitle={
            <FlexCol>
              <Text level={4} fontWeight={700}>
                เพิ่มร้านค้าและสินค้า
              </Text>
              <br />
              <FlexRow align='end'>
                <Text color='Text3' level={6}>
                  เลือกได้มากกว่า 1 ร้านค้า
                </Text>
              </FlexRow>
            </FlexCol>
          }
          hideCurrect
        />
      )}
      {modalConfirmDelete && (
        <ConfirmModal
          visible={modalConfirmDelete}
          onConfirm={() => {
            deleteShop();
            setModalConfirmDelete(false);
          }}
          onCancel={() => {
            setModalConfirmDelete(false);
          }}
          typeButtonSubmit='danger'
          typeButtonCancel='border-danger'
          title={`ต้องการลบร้านค้า ${form2.getFieldValue("stores").filter((s) => s.isChecked).length} รายการ`}
          desc='โปรดตรวจสอบรายละเอียดอีกครั้งก่อนการกดยืนยัน เพราะอาจส่งผลต่อข้อมูลร้านค้าในระบบ'
        />
      )}
      {modalSettingCondition && (
        <SettingConditionQuotaEachShop
          open={modalSettingCondition}
          onClose={() => {
            const findValue = form2.getFieldValue("stores");
            const mapValue = findValue?.map((item) => {
              if (item.isChecked) {
                return {
                  ...item,
                  isChecked: false,
                };
              }
              return item;
            });
            form2.setFieldValue("stores", mapValue);
            setModalSettingCondition(false);
          }}
          onSubmit={(q, l, conditionType) => {
            const findValue = form2.getFieldValue("stores");
            const mapValue = findValue?.map((item) => {
              if (item.isChecked) {
                form2.setFieldValue(
                  `quotaReceive-${item?.customerCompanyId}`,
                  conditionType.includes("quota")
                    ? q
                    : form2.getFieldValue(`quotaReceive-${item?.customerCompanyId}`) || null,
                );
                form2.setFieldValue(
                  `orderPerDay-${item?.customerCompanyId}`,
                  conditionType.includes("limit")
                    ? l
                    : form2.getFieldValue(`orderPerDay-${item?.customerCompanyId}`) || null,
                );
                return {
                  ...item,
                  isChecked: false,
                };
              }
              return item;
            });
            form2.setFieldValue("stores", mapValue);
            setModalSettingCondition(false);
          }}
          showQuota={dataForm1.quotaType !== "QUOTA_TOTAL"}
          showLimit={dataForm1.limitOrderDay}
          typeLimitQuota={dataForm1.limitOrderPerDayType}
          countOrder={dataForm1.countOrder}
        />
      )}
      {modalIntructCondition && (
        <InstuctionQuotaConditions
          open={modalIntructCondition}
          onClose={() => setModalIntructCondition(false)}
        />
      )}
      {modalDupProducts.open && (
        <ModalCheckProductDup
          visible={modalDupProducts.open}
          onCancel={() => setModalDupProducts({ open: false, products: [], cusName: "" })}
          products={modalDupProducts?.products}
          cusName={modalDupProducts?.cusName}
        />
      )}
      {modalDupQuota.open && (
        <ModalCheckQuotaDup
          open={modalDupQuota.open}
          onCancel={() => setModalDupQuota({ open: false, quotas: [], cusName: "" })}
          datas={modalDupQuota?.quotas}
          cusName={modalDupQuota?.cusName}
        />
      )}
    </>
  );
};
export default StepThreeDup;
